<template>
    <div class="hello">
        <br>
        <br>
        <h1>{{ post.suburb }}, {{ post.state }}  {{ post.postcode }} </h1>
        <div v-if=post.description>
          <br>
          <p style="white-space: pre-wrap" v-html='post.description'> </p>
          <br>
          <br>
        </div>

        <Share :pageUrl="pageUrlShare" />
        
        <div>
          <b>Demographic data</b>
            <v-btn
              icon
              @click="show = !show"
              >
              <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
             </v-btn>
        </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip 
                  class="ma-1"
                  color="primary"
                  label
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>
                    mdi-account-group
                  </v-icon>
                  <b>Population:&nbsp; {{ post.census_2021.population_total }}</b>
                </v-chip>
              </template>
              <span>Suburb population based on Census Data, 2021</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip 
                  class="ma-1"
                  color="primary"
                  label
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>
                    mdi-account-cash
                  </v-icon>
                  <b v-if=post.ato>Median income:&nbsp;{{ post.ato.postcode_median_19_20_tax_income }}</b>
                  <b v-else>Median income:&nbsp; {{ post.census_2016.median_income }}</b>
                </v-chip>
              </template>
              <span v-if=post.ato>Postcode median taxable income based on ATO, FY 19/20</span> 
              <span v-else>Suburb median income based on Census Data, 2016</span>
            </v-tooltip>

            <v-chip
              class="ma-1"
              color="primary"
              label
            >
              <v-icon left>
                mdi-office-building-marker
              </v-icon>
              <b>LGA:&nbsp;</b>{{ post.local_goverment_area }}
            </v-chip>

            <v-chip
              class="ma-1"
              color="primary"
              label
            >
              <v-icon left>
                mdi-texture
              </v-icon>
              <b>Area:&nbsp;</b>{{ post.sqkm }} &#13218;
            </v-chip>

          <v-expand-transition>
            <div v-show="show">
              <v-divider></v-divider>
              <v-card-text>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip 
                      class="ma-1"
                      color="primary"
                      label
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>
                        mdi-face-man
                      </v-icon>
                      <b>Population Male:&nbsp; {{ post.census_2021.population_male }}</b>
                    </v-chip>
                  </template>
                  <span>Suburb population based on Census Data, 2021</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip 
                      class="ma-1"
                      color="primary"
                      label
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>
                        mdi-face-woman
                      </v-icon>
                      <b>Population Female:&nbsp; {{ post.census_2021.population_female }}</b>
                    </v-chip>
                  </template>
                  <span>Suburb population based on Census Data, 2021</span>
                </v-tooltip>

              </v-card-text>
            </div>
          </v-expand-transition>

          <p></p>

          <b>Schools</b>
          <p></p>
        <v-container fluid>
    <v-row justify="center">

      <v-expansion-panels popout>
        <v-expansion-panel
          v-for="(item, index) in post.schools"
          :key="index"
          hide-actions
        >
          <v-expansion-panel-header>
            <v-row
              align="center"
              class="spacer"
              no-gutters
            >
              <v-col
                class="hidden-xs-only"
                sm="5"
                md="3"
              >
                <strong v-html="item.school_name"></strong>
              </v-col>

              <v-col
                class="text-no-wrap"
                cols="5"
                sm="3"
              >

                <v-chip
                  v-for="details in item.details"
                  class="ml-0 mr-2 black--text"
                  label
                  small
                >
                  {{details}}
                </v-chip>
              </v-col>

            </v-row>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider></v-divider>
            <v-card-text>
              <b>Address:</b> {{ item.street }} - {{ item.suburb }}
              <br>
              <b>Contact:</b> {{ item.contact }}

            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
  <p></p>
          <div><b>Popular stores</b></div>

          <v-tooltip v-for="(item, index) in post.stores" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip 
                class="ma-2"
                color="black"
                label
                v-bind="attrs"
                v-on="on"
                outlined
                large
              >
              <v-avatar left>
              <img :src=getImgUrl(index) :alt=getImgAlt(index)  >
            </v-avatar>
               <b> {{ getFriendlyName(index) }} </b>
              </v-chip>
            </template>
            <span>{{ item }}</span>
          </v-tooltip>
          <p></p>
    
        <div><b>Map</b></div>
          <GoogleMap :LatLngDetails="coords" />


    </div>
</template>

<script>

import GoogleMap from './GoogleMap.vue'
import Share from '../components/Share.vue'

export default {
  name: 'SuburbDetails',
  data: () => ({
      show: false,
    }),
  props: {
    post: {},
    props: ['query'],
  },
  components: {
    GoogleMap,
    Share
  },
  computed: {
    coords () {
      console.log(this.post)
      return { lat: this.post.lat , lng: this.post.lng }
    },
    pageUrlShare() {
      const urlBase = "https://www.inthesuburbs.com.au/suburb?name="
      var urlPath = this.post.suburb + "," + this.post.state + " " + this.post.postcode
      var url = urlBase + urlPath
      return url
    },
  },
  methods: {
      getImgUrl(x){
        var images = require.context('../assets/', false, /\.png$/)
        const imageName = x.split('_')[0]
        return images('./' + imageName + "-logo.png")
      },
      getImgAlt(x){
        return x.split('_')[0]
      },
      getFriendlyName(x){
        const storeName = x.split('_')[0]
        var friendlyName = ""
        if (storeName == "coles")
          friendlyName = "Coles"
        else if (storeName == "woolies")
        friendlyName = "Woolworths"
        else if (storeName == "aldi")
        friendlyName = "Aldi"
        else if (storeName == "harrisfarm")
        friendlyName = "Harris Farm"
        return friendlyName
      }
   }
  
}
 
</script>